module.exports = __webpack_public_path__ + "img/check.457fe917.png";